module.exports = "/_next/static/images/4bfb91453cda83c84daa6c8e20786742-dress-code-4.png.webp";